import { FC } from 'react';
import {
    POLICY_TEMPLATE_STATIC_CATEGORY_TO_BACKGROUND_COLOR,
    PolicyTemplateStaticCategory,
    PolicyTemplateTypeId
} from '../../../../types/policies';
import { usePolicyTemplatesContext } from '../context/PolicyTemplatesContext';

interface Props {
    type: PolicyTemplateTypeId;
}

const getTemplateBackgroundColor = (
    type: PolicyTemplateTypeId,
    categories: Array<{ id: PolicyTemplateTypeId; backgroundColor?: string }>
): string | undefined => {
    if ((Object.values(PolicyTemplateStaticCategory) as string[]).includes(type)) {
        return POLICY_TEMPLATE_STATIC_CATEGORY_TO_BACKGROUND_COLOR[type];
    }
    return categories.find((category) => category.id === type)?.backgroundColor;
};

const TemplateMedia: FC<Props> = ({ type, children }) => {
    const { categories } = usePolicyTemplatesContext();
    const backgroundColor = getTemplateBackgroundColor(type, categories);
    return (
        <div className={`relative w-full h-full overflow-hidden`} style={{ backgroundImage: backgroundColor }}>
            <div className="absolute inset-0">{children}</div>
        </div>
    );
};

export default TemplateMedia;
